import * as React from 'react'

import { ProductDetailSlotsProvider } from '@grandvisionhq/fun-products'
import { WishlistButton } from '@grandvisionhq/fun-wishlist/button'
import { NextPage, withErrorPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/sunglasses'
import { CrossSellProductsGraphContainer } from '@grandvisionhq/www-next/slot-components/CrossSellProductsGraphContainer'
import { DeliveryIndicatorGraphContainer } from '@grandvisionhq/www-next/slot-components/DeliveryIndicatorGraphContainer'
import { PromoteInstallmentsGraphContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsGraphContainer'
import { RxGlassesConfiguratorGraphContainer } from '@grandvisionhq/www-next/slot-components/RxGlassesConfiguratorGraphContainer'

import { withCms, withLayout } from '../../../cms'
import { defaultErrorProps } from '../../../components/error-props'
import OpticianForm from '../../../components/forms/Optician'
import { withCart } from '../../../components/hocs/with-cart'
import {
  getDeliveryIndicatorConfig,
  getSpecifications,
  graphPromoteInstallmentsConfiguration,
} from '../../../configuration'
import { deliveryResolverFactory } from '../../../util/delivery-resolver-factory'

import '@grandvisionhq/reviews/dist/index.css'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const { productType } = props.product
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const specificationConfiguration = getSpecifications(productType)

  return (
    <ProductDetailSlotsProvider
      slots={{
        AfterPrice: () => (
          <PromoteInstallmentsGraphContainer
            opcoConfiguration={graphPromoteInstallmentsConfiguration}
          />
        ),
        BeforeUsps: () => (
          <DeliveryIndicatorGraphContainer deliveryResolverFactory={deliveryResolverFactory} />
        ),
        Configurator: (props) => (
          <RxGlassesConfiguratorGraphContainer {...props} opticianForm={OpticianForm} />
        ),
        SecondaryProductInfoSlotA: CrossSellProductsGraphContainer,
        WishlistButton,
      }}
    >
      <Page
        {...props}
        colorFeatureIcons="orange"
        deliveryIndicatorConfig={deliveryIndicatorConfig}
        specificationConfiguration={specificationConfiguration}
      />
    </ProductDetailSlotsProvider>
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(
  withCms(),
  withErrorPage(defaultErrorProps),
  withLayout(),
  withCart({ readOnly: true })
)(ProductDetailPage)
